import api from '@/api';
import { useSaleId } from '@/hooks/sale/use-sale-id';
import { resolveGroupEntryPath } from '@/lib/group-entry';
import { useAuthStore } from '@/stores/auth.store';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

export function useSwitchAuthContextMutation() {
  const queryClient = useQueryClient();
  const login = useAuthStore((state) => state.login);
  const navigate = useNavigate();
  const { resetSaleId } = useSaleId();

  return useMutation({
    mutationKey: ['switch-auth-context'],
    mutationFn: (groupId: string) => api.auth.session.switchContext(groupId),
    onSuccess: async (data) => {
      login(data.token);
      resetSaleId();
      queryClient.clear();

      const { context } = useAuthStore.getState();
      navigate(await resolveGroupEntryPath(context!.groupId));
    },
  });
}
